import { z } from 'zod'

export const commerceAttributeSourceSchema = z.enum([
  'manual',
  'supplier',
  'productAI',
  'derived',
  'legacy',
])
export type CommerceAttributeSource = z.infer<typeof commerceAttributeSourceSchema>

export const commerceAttributeMetadataSchema = z.object({
  source: commerceAttributeSourceSchema,
  confidence: z.number().min(0).max(1).optional(),
  reviewed: z.boolean().optional(),
  evidence: z.string().optional(),
  changedAt: z.string().optional(),
})
export type CommerceAttributeMetadata = z.infer<typeof commerceAttributeMetadataSchema>

export const commerceMeasureSchema = z.object({
  value: z.number().positive(),
  unit: z.string().min(1),
})
export type CommerceMeasure = z.infer<typeof commerceMeasureSchema>

export const commerceCertificationSchema = z.object({
  authority: z.string().min(1),
  name: z.string().min(1),
  code: z.string().min(1).optional(),
  value: z.string().min(1).optional(),
})
export type CommerceCertification = z.infer<typeof commerceCertificationSchema>

export const commerceProductDetailSchema = z.object({
  sectionName: z.string().min(1),
  attributeName: z.string().min(1),
  attributeValue: z.string().min(1),
})
export type CommerceProductDetail = z.infer<typeof commerceProductDetailSchema>

export const commerceAttributesSchema = z.object({
  color: z.string().optional(),
  material: z.string().optional(),
  pattern: z.string().optional(),
  size: z.string().optional(),
  sizeSystem: z.string().optional(),
  sizeType: z.string().optional(),
  gender: z.enum(['male', 'female', 'unisex']).optional(),
  ageGroup: z.enum(['newborn', 'infant', 'toddler', 'kids', 'adult']).optional(),

  unitPricingMeasure: commerceMeasureSchema.optional(),
  unitPricingBaseMeasure: commerceMeasureSchema.optional(),
  multipack: z.number().int().positive().optional(),

  productLength: commerceMeasureSchema.optional(),
  productWidth: commerceMeasureSchema.optional(),
  productHeight: commerceMeasureSchema.optional(),
  productWeight: commerceMeasureSchema.optional(),

  certifications: z.array(commerceCertificationSchema).optional(),
  productHighlights: z.array(z.string()).optional(),
  productDetails: z.array(commerceProductDetailSchema).optional(),

  metadata: z.record(z.string(), commerceAttributeMetadataSchema).optional(),
})
export type CommerceAttributes = z.infer<typeof commerceAttributesSchema>
